// Clients: the list, one client, edit, and the dispute file.
import { createRoute } from "@tanstack/react-router";
import { AgencyClient, AgencyClients } from "../../screens/Agency";
import { ClientForm, ClientPage, ClientsList } from "../../screens/Clients";
import { DisputeFilePage } from "../../screens/DisputeFile";
import { Allowed, app, ByTrade, page } from "./base";

// Clients, jobs, the schedule and visits (draft 2).
const clientPage = createRoute({
  getParentRoute: () => app,
  path: "/clients/$id",
  component: function ClientRoute() {
    const { id } = clientPage.useParams();
    return (
      <Allowed action="client.read">
        <ByTrade agency={<AgencyClient key={id} id={id} />} other={<ClientPage key={id} id={id} />} />
      </Allowed>
    );
  },
});

/** The dispute file: kept off the menus, opened from the client's More menu or an invoice's dispute banner. */
const clientDispute = createRoute({
  getParentRoute: () => app,
  path: "/clients/$id/dispute",
  validateSearch: (s: Record<string, unknown>): { invoice?: string } =>
    typeof s.invoice === "string" && /^[0-9a-f-]{36}$/.test(s.invoice) ? { invoice: s.invoice } : {},
  component: function ClientDisputeRoute() {
    const { id } = clientDispute.useParams();
    const { invoice } = clientDispute.useSearch();
    return (
      <Allowed action="dispute.read">
        <DisputeFilePage key={`${id}:${invoice ?? ""}`} clientId={id} {...(invoice ? { invoiceId: invoice } : {})} />
      </Allowed>
    );
  },
});

const clientEdit = createRoute({
  getParentRoute: () => app,
  path: "/clients/$id/edit",
  component: function ClientEditRoute() {
    const { id } = clientEdit.useParams();
    return (
      <Allowed action="client.update">
        <ClientForm key={id} id={id} />
      </Allowed>
    );
  },
});

export const clientRoutes = [
  page("/clients", () => (
    <Allowed action="client.read">
      <ByTrade agency={<AgencyClients />} other={<ClientsList />} />
    </Allowed>
  )),
  page("/clients/new", () => (
    <Allowed action="client.update">
      <ClientForm />
    </Allowed>
  )),
  clientPage,
  clientEdit,
  clientDispute,
] as const;
